import Accordion, { mdbAccordion } from './Advanced/Accordion.vue'
import AccordionPane, { mdbAccordionPane } from './Advanced/AccordionPane.vue'
import Alert, { mdbAlert } from './Components/Alert.vue'
import Badge, { mdbBadge } from './Components/Badge.vue'
import Breadcrumb, { mdbBreadcrumb } from './Navigation/Breadcrumb.vue'
import BreadcrumbItem, { mdbBreadcrumbItem } from './Navigation/BreadcrumbItem.vue'
import Btn, { mdbBtn } from './Components/Button.vue'
import BtnGroup, { mdbBtnGroup } from './Components/ButtonGroup.vue'
import BtnToolbar, { mdbBtnToolbar } from './Components/ButtonToolbar.vue'
import Card, { mdbCard } from './Components/Card.vue'
import CardAvatar, { mdbCardAvatar } from './Components/CardAvatar.vue'
import CardBody, { mdbCardBody } from './Components/CardBody.vue'
import CardFooter, { mdbCardFooter } from './Components/CardFooter.vue'
import CardGroup, { mdbCardGroup } from './Components/CardGroup.vue'
import CardHeader, { mdbCardHeader } from './Components/CardHeader.vue'
import CardImg, { mdbCardImage } from './Components/CardImg.vue'
import CardUp, { mdbCardUp } from './Components/CardUp.vue'
import CardText, { mdbCardText } from './Components/CardText.vue'
import CardTitle, { mdbCardTitle } from './Components/CardTitle.vue'
import Carousel, { mdbCarousel } from './Advanced/Carousel.vue'
import CarouselCaption, { mdbCarouselCaption } from './Advanced/CarouselCaption.vue'
import CarouselIndicator, { mdbCarouselIndicator } from './Advanced/CarouselIndicator.vue'
import CarouselIndicators, { mdbCarouselIndicators } from './Advanced/CarouselIndicators.vue'
import CarouselInner, { mdbCarouselInner } from './Advanced/CarouselInner.vue'
import CarouselItem, { mdbCarouselItem } from './Advanced/CarouselItem.vue'
import CarouselNavigation, { mdbCarouselControl } from './Advanced/CarouselNavigation.vue'
import BarChart, { mdbBarChart } from './Advanced/ChartBar'
import DoughnutChart, { mdbDoughnutChart } from './Advanced/ChartDoughnut'
import LineChart, { mdbLineChart } from './Advanced/ChartLine'
import PieChart, { mdbPieChart } from './Advanced/ChartPie'
import PolarChart, { mdbPolarChart } from './Advanced/ChartPolar'
import RadarChart, { mdbRadarChart } from './Advanced/ChartRadar'
import BubbleChart, { mdbBubbleChart } from './Advanced/ChartBubble'
import ScatterChart, { mdbScatterChart } from './Advanced/ChartScatter'
import HorizontalBarChart, { mdbHorizontalBarChart } from './Advanced/ChartHorizontalBar'
import Collapse, { mdbCollapse } from './Advanced/Collapse.vue'
import Column, { mdbCol } from './Layout/Col.vue'
import Container, { mdbContainer } from './Layout/Container.vue'
import DropdownItem, { mdbDropdownItem } from './Components/DropdownItem.vue'
import DropdownMenu, { mdbDropdownMenu } from './Components/DropdownMenu.vue'
import DropdownToggle, { mdbDropdownToggle } from './Components/DropdownToggle.vue'
import EdgeHeader, { mdbEdgeHeader } from './Components/EdgeHeader.vue'
import Fa, { mdbIcon } from './Content/Fa.vue'
import Footer, { mdbFooter } from './Navigation/Footer.vue'
import FormInline, { mdbFormInline } from './Forms/FormInline.vue'
import Jumbotron, { mdbJumbotron } from './Components/Jumbotron.vue'
import ListGroup, { mdbListGroup } from './Components/ListGroup.vue'
import ListGroupItem, { mdbListGroupItem } from './Components/ListGroupItem.vue'
import MdMask, { mdbMask } from './CSS/Mdmask.vue'
import Media, { mdbMedia } from './Layout/Media.vue'
import MediaBody, { mdbMediaBody } from './Layout/MediaBody.vue'
import MediaImage, { mdbMediaImage } from './Layout/MediaImage.vue'
import Modal, { mdbModal } from './Modals/Modal.vue'
import ModalBody, { mdbModalBody } from './Modals/ModalBody.vue'
import ModalFooter, { mdbModalFooter } from './Modals/ModalFooter.vue'
import ModalHeader, { mdbModalHeader } from './Modals/ModalHeader.vue'
import ModalTitle, { mdbModalTitle } from './Modals/ModalTitle.vue'
import MdTextarea, { mdbTextarea } from './Forms/MdTextarea.vue'
import Navbar, { mdbNavbar } from './Navigation/Navbar.vue'
import NavbarBrand, { mdbNavbarBrand } from './Navigation/NavbarBrand.vue'
import NavbarCollapse, { mdbNavbarToggler } from './Navigation/NavbarCollapse.vue'
import NavbarItem, { mdbNavItem } from './Navigation/NavbarItem.vue'
import NavbarNav, { mdbNavbarNav } from './Navigation/NavbarNav.vue'
import NumericInput, { mdbNumericInput } from './Forms/NumericInput.vue'
import PageItem, { mdbPageItem } from './Components/PageItem.vue'
import PageNav, { mdbPageNav } from './Components/PageNav.vue'
import Pagination, { mdbPagination } from './Components/Pagination.vue'
import Popover, { mdbPopover } from './Advanced/Popover.vue'
import Progress, { mdbProgress } from './Components/Progress.vue'
import Row, { mdbRow } from './Layout/Row.vue'
import Tabs, { mdbTabs } from './Components/Tabs.vue'
import Tab, { mdbTab } from './Components/Tab.vue'
import TabContent, { mdbTabContent } from './Components/TabContent.vue'
import TabItem, { mdbTabItem } from './Components/TabItem.vue'
import TabPane, { mdbTabPane } from './Components/TabPane.vue'
import Tbl, { mdbTbl } from './Tables/Table.vue'
import TblBody, { mdbTblBody } from './Tables/TableBody.vue'
import TblHead, { mdbTblHead } from './Tables/TableHead.vue'
import ViewWrapper, { mdbView } from './CSS/ViewWrapper.vue'
import Scrollbar, { mdbScrollbar } from './Advanced/Scrollbar.vue'
import StretchedLink, { mdbStretchedLink } from './Utilities/StretchedLink.vue'
import ToastNotification, { mdbToastNotification } from './Advanced/ToastNotification.vue'
import Masonry, { mdbMasonry } from './Layout/Masonry.vue'
import MasonryItem, { mdbMasonryItem } from './Layout/MasonryItem.vue'
import Autocomplete, { mdbAutocomplete } from './pro/Forms/Autocomplete.vue'
import Avatar, { mdbAvatar } from './pro/Content/Avatar.vue'
import BtnFixed, { mdbBtnFixed } from './pro/Components/BtnFixed.vue'
import BtnFixedItem, { mdbBtnFixedItem } from './pro/Components/BtnFixedItem.vue'
import Chip, { mdbChip } from './pro/Components/Chip.vue'
import ChipInput, { mdbChipInput } from './pro/Components/ChipInput.vue'
import CsvDownloader, { mdbCsvDownloader } from './pro/Tables/CsvDownloader.vue'
import DatePicker, { mdbDatePicker } from './pro/Forms/DatePicker.vue'
import Datatable, { mdbDatatable } from './pro/Tables/Datatable.vue'
import Dropdown, { mdbDropdown } from './pro/Components/Dropdown.vue'
import Input, { mdbInput } from './pro/Forms/Input.vue'
import Tooltip, { mdbTooltip } from './pro/Advanced/Tooltip.vue'
import FileInput, { mdbFileInput } from './pro/Forms/FileInput.vue'
import FlippingCard, { mdbFlippingCard } from './pro/Components/FlippingCard.vue'
import Lightbox, { mdbLightbox } from './pro/Advanced/Lightbox.vue'
import MiniChart, { mdbSimpleChart } from './pro/Advanced/MiniChart.vue'
import Notify from './pro/Advanced/Notify'
import Notification, { mdbNotification } from './pro/Advanced/Notification.vue'
import Preloader, { mdbSpinner } from './pro/Components/Preloader.vue'
import RangeInput, { mdbRangeInput } from './pro/Forms/RangeInput.vue'
import ScrollSpyBox, { mdbScrollspyBox } from './pro/Navigation/ScrollSpyBox.vue'
import ScrollSpyList, { mdbScrollspyList } from './pro/Navigation/ScrollSpyList.vue'
import ScrollSpyListItem, { mdbScrollspyListItem } from './pro/Navigation/ScrollSpyListItem.vue'
import ScrollSpyText, { mdbScrollspyText } from './pro/Navigation/ScrollSpyText.vue'
import { mdbSelect } from './pro/Forms/Select.vue'
import SelectInput, { mdbSelectInput } from './pro/Forms/SelectInput.vue'
import SelectOption, { mdbSelectOption } from './pro/Forms/SelectOption.vue'
import SelectOptions, { mdbSelectDropdown } from './pro/Forms/SelectOptions.vue'
import SideNav, { mdbSideNav } from './pro/Navigation/SideNav.vue'
import SideNavNav, { mdbSideNavNav } from './pro/Navigation/SideNavNav.vue'
import SideNavCat, { mdbSideNavCat } from './pro/Navigation/SideNavCat.vue'
import SideNavItem, { mdbSideNavItem } from './pro/Navigation/SideNavItem.vue'
import SubMenu, { mdbSubMenu } from './pro/Navigation/SubMenu.vue'
import MdSwitch, { mdbSwitch } from './pro/Forms/Switch.vue'
import TableEditable, { mdbTableEditable } from './pro/Tables/TableEditable.vue'
import Testimonial, { mdbTestimonial } from './pro/Components/Testimonial.vue'
import TestimonialNavigation, { mdbTestimonialNavigation } from './pro/Components/TestimonialNavigation.vue'
import TimePicker, { mdbTimePicker } from './pro/Forms/TimePicker/TimePicker.vue'
import Step, { mdbStep } from './pro/Components/Step.vue'
import Stepper, { mdbStepper } from './pro/Components/Stepper.vue'
import Streak, { mdbStreak } from './pro/Plugins/Streak.vue'
import Parallax, { mdbParallax } from './pro/CSS/Parallax.vue'
import MultiCarousel, { mdbMultiCarousel } from './pro/Advanced/MultiCarousel.vue'
import PreloadingScript, { mdbPreloadingScript } from './pro/Components/PreloadingScript.vue'
export {
	Accordion,
	AccordionPane,
	Alert,
	Badge,
	Breadcrumb,
	BreadcrumbItem,
	Btn,
	BtnGroup,
	BtnToolbar,
	Card,
	CardAvatar,
	CardBody,
	CardFooter,
	CardGroup,
	CardHeader,
	CardImg,
	CardText,
	CardTitle,
	CardUp,
	Carousel,
	CarouselCaption,
	CarouselIndicator,
	CarouselIndicators,
	CarouselInner,
	CarouselItem,
	CarouselNavigation,
	BarChart,
	DoughnutChart,
	LineChart,
	PieChart,
	PolarChart,
	RadarChart,
	BubbleChart,
	ScatterChart,
	HorizontalBarChart,
	Container,
	Collapse,
	Column,
	Datatable,
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	EdgeHeader,
	Fa,
	Footer,
	FormInline,
	Input,
	Jumbotron,
	ListGroup,
	ListGroupItem,
	MdMask,
	MdTextarea,
	Media,
	MediaBody,
	MediaImage,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
	Navbar,
	NavbarBrand,
	NavbarCollapse,
	NavbarItem,
	NavbarNav,
	NumericInput,
	PageItem,
	PageNav,
	Pagination,
	Popover,
	Progress,
	Row,
	Tabs,
	Tab,
	TabContent,
	TabItem,
	TabPane,
	Tbl,
	TblBody,
	TblHead,
	Tooltip,
	ViewWrapper,
	Scrollbar,
	StretchedLink,
	ToastNotification,
	Masonry,
	MasonryItem,
	Autocomplete,
	Avatar,
	BtnFixed,
	BtnFixedItem,
	Chip,
	ChipInput,
	CsvDownloader,
	DatePicker,
	FlippingCard,
	FileInput,
	MdSwitch,
	MiniChart,
	Notify,
	Notification,
	Lightbox,
	Preloader,
	RangeInput,
	ScrollSpyBox,
	ScrollSpyList,
	ScrollSpyListItem,
	ScrollSpyText,
	SideNav,
	SideNavNav,
	SideNavCat,
	SideNavItem,
	SubMenu,
	SelectInput,
	SelectOptions,
	SelectOption,
	Step,
	Stepper,
	Streak,
	TableEditable,
	Testimonial,
	TestimonialNavigation,
	TimePicker,
	Parallax,
	MultiCarousel,
	PreloadingScript,
	mdbAccordion,
	mdbAccordionPane,
	mdbAlert,
	mdbBadge,
	mdbBreadcrumb,
	mdbBreadcrumbItem,
	mdbBtn,
	mdbBtnGroup,
	mdbBtnToolbar,
	mdbCard,
	mdbCardAvatar,
	mdbCardBody,
	mdbCardFooter,
	mdbCardGroup,
	mdbCardHeader,
	mdbCardImage,
	mdbCardText,
	mdbCardTitle,
	mdbCardUp,
	mdbCarousel,
	mdbCarouselCaption,
	mdbCarouselControl,
	mdbCarouselIndicator,
	mdbCarouselIndicators,
	mdbCarouselInner,
	mdbCarouselItem,
	mdbBarChart,
	mdbDoughnutChart,
	mdbLineChart,
	mdbPieChart,
	mdbPolarChart,
	mdbRadarChart,
	mdbBubbleChart,
	mdbScatterChart,
	mdbHorizontalBarChart,
	mdbCol,
	mdbCollapse,
	mdbContainer,
	mdbDatatable,
	mdbDropdown,
	mdbDropdownItem,
	mdbDropdownMenu,
	mdbDropdownToggle,
	mdbEdgeHeader,
	mdbIcon,
	mdbInput,
	mdbFooter,
	mdbFormInline,
	mdbJumbotron,
	mdbListGroup,
	mdbListGroupItem,
	mdbMask,
	mdbMedia,
	mdbMediaBody,
	mdbMediaImage,
	mdbModal,
	mdbModalHeader,
	mdbModalTitle,
	mdbModalBody,
	mdbModalFooter,
	mdbNumericInput,
	mdbNavbar,
	mdbNavbarBrand,
	mdbNavbarNav,
	mdbNavbarToggler,
	mdbNavItem,
	mdbPageItem,
	mdbPageNav,
	mdbPagination,
	mdbPopover,
	mdbProgress,
	mdbRow,
	mdbTabs,
	mdbTab,
	mdbTabContent,
	mdbTabItem,
	mdbTabPane,
	mdbTbl,
	mdbTblBody,
	mdbTblHead,
	mdbTextarea,
	mdbTooltip,
	mdbView,
	mdbScrollbar,
	mdbStretchedLink,
	mdbToastNotification,
	mdbMasonry,
	mdbMasonryItem,
	// removeIf(free)
	mdbAutocomplete,
	mdbAvatar,
	mdbBtnFixed,
	mdbBtnFixedItem,
	mdbChip,
	mdbChipInput,
	mdbCsvDownloader,
	mdbDatePicker,
	mdbFileInput,
	mdbFlippingCard,
	mdbLightbox,
	mdbNotification,
	mdbRangeInput,
	mdbSpinner,
	mdbScrollspyBox,
	mdbScrollspyList,
	mdbScrollspyListItem,
	mdbScrollspyText,
	mdbSwitch,
	mdbTableEditable,
	mdbTestimonial,
	mdbTestimonialNavigation,
	mdbTimePicker,
	mdbSelect,
	mdbSelectDropdown,
	mdbSelectInput,
	mdbSelectOption,
	mdbSideNav,
	mdbSideNavNav,
	mdbSideNavCat,
	mdbSideNavItem,
	mdbSimpleChart,
	mdbStep,
	mdbStepper,
	mdbStreak,
	mdbSubMenu,
	mdbParallax,
	mdbMultiCarousel,
	mdbPreloadingScript
}
